import { Sortable } from 'sortablejs';

// used for dragging and dropping rows in a table
export default {
  bind(el, binding, vnode) {
    const tbody = el.getElementsByTagName('tbody')[0];
    // On phones the table is a list of rows (BasePhoneTable), with no body to reorder.
    if (!tbody) return;
    const options = {
      animation: 150,
      handle: '.drag-handle', // elements with this class will be draggable
      filter: '.non-draggable', // elements with this class won't be draggable
      onUpdate(event) {
        vnode.child.$emit('sorted', event);
      },
    };
    const custom = binding.value && typeof binding.value === 'object' ? binding.value : {};
    if (typeof custom.getMoveAllowed === 'function') {
      options.onMove = function (ev) {
        const children = Array.from(tbody.children);
        const oldIndex = children.indexOf(ev.dragged);
        let newIndex = children.indexOf(ev.related);
        if (ev.willInsertAfter) newIndex += 1;
        return custom.getMoveAllowed(oldIndex, newIndex);
      };
    }
    Sortable.create(tbody, options);
  },
};
